exports = module.exports = require("../../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".el-radio-group{display:inline-block;line-height:1;vertical-align:middle;font-size:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/element-ui/lib/theme-chalk/radio-group.css
// module id = 576
// module chunks = 40